// eslint-disable-next-line import/prefer-default-export
export const UPDATE_GLOBAL_SETUP = 'UPDATE_GLOBAL_SETUP';
export const UPDATE_GLOBAL_SETUP_ERROR = 'UPDATE_GLOBAL_SETUP_ERROR';
